import SmartGroups from './smart-groups';
export default SmartGroups;
